// extracted by mini-css-extract-plugin
export default {"tooltip":"ReorderingTooltip_tooltip__Vnk7Y","slideDown":"ReorderingTooltip_slideDown__NfqDJ"};